module.exports = __webpack_public_path__ + "img/c67.f7d2d78e.png";